import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import Footer from "./components/Footer";
import CRMPage from "./pages/CRM/LeadManagement";
import "./i18n";
import Login from "./pages/CRM/login";
import ProtectedRoute from "./context/ProtectedRoute";
import AGBs from "./pages/Agbs";
import Impressum from "./pages/Impressum";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";


function LanguageSync() {
  const location = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    // Check if 'en' is a segment in the URL (e.g., /en/agbs or /admin/en/crm/lead)
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const isEn = pathSegments.includes("en");
    const currentLang = isEn ? "en" : "de";
    
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [location.pathname, i18n]);
  return null;
}

export default function App() {
  return (
 <BrowserRouter>
 <LanguageSync />
  <Routes>
    {/* 1. Base Routes (German - No prefix) */}
    <Route path="/" element={<HomePage />} />
    <Route path="/agbs" element={<AGBs />} />
    <Route path="/impressum" element={<Impressum />} />
<Route path="/:lang/login" element={<Login />} /> 
  <Route path="/login" element={<Login />} />

    {/* 2. English Routes (With /en/ prefix) */}
    <Route path="/en" element={<HomePage />} />
    <Route path="/en/agbs" element={<AGBs />} />
    <Route path="/en/impressum" element={<Impressum />} />
    <Route path="/en/login" element={<Login />} />

    {/* 3. Admin Routes */}
    <Route path="/admin" element={<ProtectedRoute />}>
      {/* English: /admin/en/crm/lead */}
      <Route path="en/crm/lead" element={<CRMPage />} />
      
      {/* German (Base): /admin/crm/lead */}
      <Route path="crm/lead" element={<CRMPage />} />
      
      {/* Catch-all redirect for admin */}
      <Route path="lead" element={<Navigate to="/admin/crm/lead" replace />} />
    </Route>

    {/* 4. Redirects to clean up old URLs */}
    <Route path="/de" element={<Navigate to="/" replace />} />
    <Route path="/de/*" element={<Navigate to="/" replace />} />
    
    {/* 5. 404 Fallback */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
</BrowserRouter>
  );
}